// 会员身份 0: 个人 1: 采购商 2: 供应商 3: 双重身份
export const USER_TYPE = {
  PURCHASE: '1',
  PERSONAL: '0',
  SUPPLY: '2',
  ALL: '3',
};
// 是否是管理员
export const ADMIN = {
  YES: 1,
  NO: 0,
};
// 审核状态 默认101：未提交、102：待审核、103：审核未通过、104：审核通过
export const TEMPORARY_STATUS = {
  NOT_SUBMITTED: '101',
  TO_BE_REVIEWED: '102',
  FAIL: '103',
  SUCCESS: '104',
};
